<template>
  <div class="list-by-date">
    <div class="results__input-date">
      <select v-on:change="changeLottery" v-model="filterGame" class="form-control">
        <option :value="this.$store.getters.getAccountProducts[0].gameSlug">Select Game</option>
        <option
                v-for="(game, i) in $store.getters.getAccountProducts"
                :key="i"
                :value="game.gameSlug"
        >
          {{ game.name }}
        </option>
      </select>
    </div>
    <template v-if="!isLoading">
      <v-result-details :drawResults="accountPastGameResults"></v-result-details>
      <div v-if="isLoadMore" class="list-by-date__load-more">
        <button @click="handleLoadMore()">LOAD MORE</button>
      </div>
    </template>
    <template v-if="isLoading">
      <Loading />
    </template>
  </div>
</template>
<script>
  import Details from "./details";
  import Loading from '@/components/common/loading/Loading.vue'
  export default {
    components: {
      'v-result-details': Details,
      Loading
    },
    data () {
      return {
        filterGame: (this.gameSlug)?this.gameSlug:'',
        countMoreItems: 10,
        isLoading: true,
        isLoadMore: true
      }
    },
    watch: {
      accountPastGameResults: function(val) {
        if(val.length > 0)  {
          this.isLoading = false
        }
        this.isLoadMore = val.length < this.$store.getters.getPastGameResults.length;
      }
    },
    computed: {
      accountPastGameResults: function () {
        return this.fnPastGameResults()
      }
    },
    methods: {
      getInitialLoad() {
        const games = this.$store.getters.getAccountProducts
        this.filterGame = games[0].gameSlug
        this.$store.dispatch('apiGetResults', {gameSlug: this.filterGame})
      },
      fnPastGameResults: function() {
        let data = this.$store.getters.getPastGameResults
        if(data.length !== undefined && data.length > 0) {
          data.forEach(item => {
            item.srcLogo = item.logo.split('flags-v2/').pop().replace(".svg", ".png")
          })
          return data.filter((game, index) => index < this.countMoreItems)
        }
        return this.$store.getters.getPastGameResults
      },
      getNextBatchByName() {
        let data = this.$store.getters.getPastGameResults
        this.countMoreItems = this.countMoreItems + 10
        return data.filter((game, index) => index < this.countMoreItems)
      },
      changeLottery: function () {
        this.countMoreItems = 10
        this.isLoading = true
        this.$store.dispatch('apiGetResults', {gameSlug: this.filterGame})
      },
      handleLoadMore() {
        this.getNextBatchByName();
      },
    },
    beforeMount() {
      this.getInitialLoad();
    }
  }
</script>
<style scoped lang="scss" src="@/assets/scss/results/listByDate.scss"/>
